import './spektrixBasket.html.twig';
import './spektrixBasket.css';

export default function() {
  const el = document.querySelector('.spektrix-basket');
  if (!el) {
    return;
  }
  el.addEventListener('click', () => {
    const url = `/tickets/basket`;
    const w = window.open(url, 'spektrix', 'height=800,width=640');
    w.addEventListener('beforeunload', () => {
      window.location.reload();
    });
  });
}
